import * as React from "react";
function IndexUp(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width={props?.width || "6"}
      height={props?.height || "3"}
      viewBox={props?.viewBox || "0 0 6 3"}
    >
      <path id="Polygon_5" data-name="Polygon 5" d="M3,0,6,3H0Z" />
    </svg>
  );
}
export default IndexUp;
